export const CaseStatus = (val, role, display_labels) => {
  const defaultRole =
    role === 'NL_Pathologist'
      ? 'pathologist'
      : role === 'NL_WOMA_ADMIN'
      ? 'it_admin'
      : role === 'NL_LabManager'
      ? 'lab_manager'
      : role === 'NL_SpecimenLogistics'
      ? 'logistics'
      : role
  const obj = Object.entries(display_labels?.case_status).filter(([key]) => key == val)
  const labelArr = obj.length > 0 && Object.entries(obj[0][1].label).filter(([key]) => key == defaultRole)
  const labelColor = obj.length > 0 && obj[0][1].label_color

  return {
    labelStr: labelArr ? labelArr[0][1] : '-',
    labelColor: labelColor ? labelColor : '#c51162',
  }
}
export const SlideStatus = (val, role, display_labels) => {
  const defaultRole =
    role === 'NL_Pathologist'
      ? 'pathologist'
      : role === 'NL_WOMA_ADMIN'
      ? 'it_admin'
      : role === 'NL_LabManager'
      ? 'lab_manager'
      : role === 'NL_SpecimenLogistics'
      ? 'logistics'
      : role

  const obj = Object.entries(display_labels?.slide_location).filter(([key, value]) => key == val)

  const labelArr = Object.entries(obj[0][1].label).filter(([key]) => key == defaultRole)
  return labelArr ? labelArr[0][1] : '-'
}
